import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC6CJLshj9rBZN4IGqJa2uUdcDAMJIOIU8",
  authDomain: "womenproject-1718050454162.firebaseapp.com",
  projectId: "womenproject-1718050454162",
  storageBucket: "womenproject-1718050454162.appspot.com",
  messagingSenderId: "33615168551",
  appId: "1:33615168551:web:db0464c6651112eddb7a02",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
